const hy = [
  {
    id: 1,
    from: 1,
    to: 33,
    label: 'Չափազանց շատ տեղեկատվություն',
  },
  {
    id: 2,
    from: 34,
    to: 68,
    label: 'Անբավարար իմաստ',
  },
  {
    id: 3,
    from: 69,
    to: 97,
    label: 'Պետք է արագ գործել',
  },
  {
    id: 4,
    from: 98,
    to: 105,
    label: 'Ի՞նչ պետք է հիշել',
  },
];

export default hy;
